import svgConnect from "../../../../assets/imgs/socials/connects/facebookGroups.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/facebookGroups.svg";

import MyImage from "../../../myImage"

const MyIconFacebookGroups = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'facebook icon'} sx={sx} />

export default MyIconFacebookGroups;
